<template>
  <div class="w-full max-w-[1160px] min-w-[463px] h-100 overflow-auto pt-[36px] px-[32px] flex flex-col mx-auto nosology-page">
    <!-- Header -->
    <div class="flex justify-between items-center">
      <span class="text-v-ui-text-monochrome title-24-medium-500">Нозологии</span>
      <v-button type="primary" label="Добавить нозологию" @click="openAddNosologyPage" size="s" />
    </div>
    <!-- End Header -->
    <!-- Content -->
    <div class="mt-[24px] flex flex-col flex-1 min-h-0">
      <v-input
       v-model="searchString"
       placeholder="Введите наименование нозологии"
       @input="fetchDebouncedNosologyList"
       class="!h-[40px] nosology-search-input"
       contentWidth
       :leftIcon="{ name: 'search' }"
       variant="white"
      />

      <div v-if="isError" class="mt-[40px] flex-1 min-h-0 flex">
        <v-placeholder
          message="Что-то пошло не так"
          description="Попробуйте повторить запрос <br> или обратитесь в службу поддержки"
          :icon="{ name: 'xl/mood-confuzed' }"
          :retry="{ label: 'Повторить запрос', handler: fetchNosologyList }"
          class="!min-h-[70vh] h-full w-full !p-[24px]"
        >
          <template #footer>
            <p class="text-14-reg-400">Позвонить в техподдержку</p>
            <a
              class="text-v-ui-text-main text-14-reg-400 mt-[8px]"
              href="tel:88005000299"
              >8 800 500-02-99</a
            >
          </template>
        </v-placeholder>
      </div>


      <VPlaceholder v-else-if="totalCountInBase === 0 && !isFetching"
        message="Нозологий ещё нет"
        :icon="{ name: 'xl/list-check' }"
        class="!min-h-[70vh] mt-[40px] flex-1"
      />

      <VPlaceholder v-else-if="searchString && totalCount === 0 && !isFetching"
        message="Нозологии не найдены"
        :icon="{ name: 'xl/table-search' }"
        class="!min-h-[70vh] mt-[40px] flex-1"
      />

      <template v-else-if="isFetching" >
        <div class="flex flex-col rounded-[8px] bg-white border brd-accent-neutral-secondary mt-[40px] overflow-hidden">
          <div>
            <v-table-head :loading="true" />
            <v-table-line :loading="true" />
            <v-table-line :loading="true" />
            <v-table-line :loading="true" />
          </div>
        </div>
      </template>

      <template v-else>
        <div class="flex flex-col mt-[24px] pb-[55px]">
          <div class="flex gap-x-[8px] py-[16px]"> <span class="title-16-medium-500 text-heading-primary !leading-[24px]">Всего нозологий</span> <v-badge type="light" size="m" :content="totalCountInBase" /></div>
          <div class="rounded-[8px] bg-white border brd-neutral-secondary min-w-[399px] max-w-[1096px]">
            <v-table-head  :cells="tableHeadCells" class="rounded-t-[8px]" />
            <div v-for="(nosology, index) in nosologyList" :key="nosology.id">
              <v-table-line :cells="generateTableLineCells(nosology)" :type="index % 2 === 0 ? 'gray' : 'white'" />
            </div>
            <v-table-pagination
             v-if="totalCount > limit"
             :dark="true"
             isAutoDropDown
             :currentPage="page" :limit="limit"
             :total="totalCount"
             @update:currentPage="onChangePage"
             @update:limit="onChangeLimit"
            />
          </div>
        </div>
      </template>

    </div>
    <!-- End Content -->

    <VDialog
      v-model="isDeleteNosologyDialogOpen"
      title="Удаление нозологии"
      subtitle="Вы хотите удалить нозологию? Это действие невозможно отменить."
      :leftButton='{"label":"Удалить", "handler": () => this.confirmDeleteNosology()}'
      :rightButton='{"label":"Не удалять","closeOnClick":true, "closeOnClick":true}'
    />
  </div>
</template>

<script>
import {
  VButton,
  VInput,
  VPlaceholder,
  VTableHead,
  VTableLine,
  VBadge,
  VTablePagination,
  VDialog,
    } from '@gostelemed.front/rt-doctis.designsystem';
import nosologyService from '@/services/nosology/nosology.service';
import debounce from 'lodash/debounce';
import { TOASTS } from '@/services/core/ui/toasts.const';


export default {
  name: 'Nosology',
  page: {
    title: 'CRM Doctis - Нозологии',
  },
  components: {
    VButton,
    VInput,
    VPlaceholder,
    VTableHead,
    VTableLine,
    VBadge,
    VTablePagination,
    VDialog
  },
  data() {
    return {
      isDeleteNosologyDialogOpen: false,
      selectedNosologyId: null,
      searchString: '',
      nosologyList: null,
      isFirstFetch: true,
      page: 1,
      limit: 10,
      isFetching: true,
      isError: false,
      totalCount: 0,
      totalCountInBase: 0,
      tableHeadCells: [
      { title: "ID", class: 'max-w-[453px]' },
      { title: "Наименование", class: 'max-w-[453px]' },
      { title: "", class: 'max-w-[158px]' },
      ]
    }
  },

  async mounted() {
    await this.fetchNosologyList();
  },

  created() {
    this.fetchDebouncedNosologyList = debounce(this.fetchNosologyList, 700);
  },

  methods: {
    async fetchNosologyList() {
      this.isFetching = true;
      try {
        if (this.isFirstFetch) {
        }
        const data = await nosologyService.getNosologyList({
          nosologyName: this.searchString,
          page: this.page,
          limit: this.limit,
        });
        this.nosologyList = data?.list;
        this.totalCount = data?.total;
        if (this.isFirstFetch) {
          this.totalCountInBase = data?.total;
          this.isFirstFetch = false;
        }
      } catch (error) {
        this.isError = true;
        console.error(error);
      } finally {
        this.isFetching = false;
      }
    },

    openAddNosologyPage() {
      this.$router.push('/remote-monitoring/kzs/nosology/add');
    },

    generateTableLineCells(nosology) {
      return [
        {
          type: "iconWithText",
          text: nosology.id,
          class: 'max-w-[453px]'
        },
        {
          type: "iconWithText",
          text: nosology.name,
          class: 'max-w-[453px]'
        },
        {
          type: "actions",
          links: [
            {
              title: "Подробнее",
              href: `/remote-monitoring/kzs/nosology/${nosology.id}`,
              target: "_self",
              spaMode: true,
              click: () => this.$router.push(`/remote-monitoring/kzs/nosology/${nosology.id}`),
            },
          ],
          icons: [
            {
              icon: "delet",
              type: "ghost",
              class: "!icon-warning-tertiary",
              handler: () => this.openDeleteNosologyDialog(nosology.id),
            },
          ],
          class: 'max-w-[158px]'
        },
      ];
    },

    openDeleteNosologyDialog(id) {
      this.isDeleteNosologyDialogOpen = true;
      this.selectedNosologyId = id;
    },

    async confirmDeleteNosology() {
      try {
        await nosologyService.deleteNosology(this.selectedNosologyId);
        this.$uiService.showToast(TOASTS.NOSOLOGY_DELETE_SUCCESS);
        this.isDeleteNosologyDialogOpen = false;
        this.selectedNosologyId = null;
        await this.fetchNosologyList();
      } catch (error) {
        this.$uiService.showToast(TOASTS.NOSOLOGY_DELETE_ERROR);
        console.error(error);
      }
    },

    async onChangePage(page) {
       this.page = page;
       await this.fetchNosologyList();
    },

    async onChangeLimit(limit) {
      this.limit = limit;
      await this.fetchNosologyList();
    },
  },
}
</script>
